// Generated from src/img/svg/norealtime.svg

export const Norealtime = (props) => {
  return (
    <svg height="42" viewBox="0 0 42 42" width="42" {...props}>
      <path
        d="M40 20A20 20 0 1 1 20 0a20 20 0 0 1 20 20"
        data-name="Pfad 1"
        fill="#353535"
      />
      <path
        d="M20.004 7.653a9.993 9.993 0 0 0-10 9.992c0 7.773 10 14.8 10 14.8s9.992-7.5 9.992-14.8a9.99 9.99 0 0 0-9.992-9.992m0 14.662a4.924 4.924 0 1 1 4.924-4.924 4.93 4.93 0 0 1-4.923 4.919"
        data-name="Pfad 2"
        fill="#fff"
      />
      <path
        d="m8.809 5.25 26.066 25.907-2.681 2.505L5.854 7.653Z"
        data-name="Pfad 3"
        fill="#ec0016"
      />
      <path
        d="M20 3.231A16.769 16.769 0 1 1 3.231 20 16.79 16.79 0 0 1 20 3.231M20 0a20 20 0 1 0 20 20A20 20 0 0 0 20 0"
        data-name="Pfad 4"
        fill="#353535"
      />
    </svg>
  );
};
